import { render, staticRenderFns } from "./SugWord.vue?vue&type=template&id=afd959f2&scoped=true&"
import script from "./SugWord.vue?vue&type=script&lang=js&"
export * from "./SugWord.vue?vue&type=script&lang=js&"
import style0 from "./SugWord.vue?vue&type=style&index=0&id=afd959f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd959f2",
  null
  
)

export default component.exports